import React, { useState, useEffect } from "react";
import { Modal, Card, Typography, message } from "antd"; 
import { fetchCuisineData } from "../useAPIDetails/useFetchUserList";

const CuisineModal = ({ userId, isOpen, onClose }) => {
  const [cuisines, setCuisines] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      const loadCuisineData = async () => {
        setIsLoading(true);
        setError("");
        try {
          const data = await fetchCuisineData(userId);
          const transformedData = data.map((cuisine) => ({
            name: cuisine.name,
            fileUrl: cuisine.coverPhoto?.fileUrl || "",
          }));
          setCuisines(transformedData);
        } catch (err) {
          message.error(
            error?.response?.data?.message ||
              "Failed to load dietary preferences."
          );
        } finally {
          setIsLoading(false);
        }
      };

      loadCuisineData();
    }
  }, [isOpen, userId]);

  return (
    <Modal
      title="Cuisines"
      open={isOpen}
      onCancel={() => {
        onClose();
        document.body.style.overflow = "";
      }}
      footer={null}
      centered
      styles={{
        body: {
          maxHeight: "55vh",
          overflowY: "auto",
          scrollbarWidth: "thin",
        },
      }}
      style={{ maxWidth: "400px", margin: "auto" }}
      afterOpenChange={(open) => {
        document.body.style.overflow = open ? "hidden" : ""; // Handle background scrolling
      }}
    >
      {isLoading ? (
        <div>Loading......</div>
      ) : error ? (
        <Typography style={{ color: "red" }}>{error}</Typography>
      ) : (
        <div
          className="modal-dialog"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          {cuisines.map((cuisine, index) => (
            <Card
              key={index}
              style={{
                backgroundImage: `url('${cuisine.fileUrl}')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "8px",
                overflow: "hidden",
                height: "170px",
              }}
              styles={{
                body: {
                height: "100%",
                display: "flex",
                alignItems: "flex-end",
                padding: 0
                },
              }}
            >
              <Typography
                style={{
                  color: "#fff",
                  fontSize: "14px",
                  background: "rgba(0, 0, 0, 0.5)",
                  padding: "4px",
                }}
              >
                {cuisine.name}
              </Typography>
            </Card>
          ))}
        </div>
      )}
    </Modal>
  );
};

export default CuisineModal;
